<template>
  <div
    v-if="data"
    :class="$style.root"
  >
    <LayoutPageContentComponent :parentTitle="parentTitle">
      <template #close>
        <i18nLink :to="{ name: 'projects' }">
          <CoreButtonsCloseComponent />
        </i18nLink>
      </template>

      <template #content>
        <LayoutHeadingComponent
          :title="page?.title"
          :subtitles="page?.secondaryTitles"
          :categories="categories"
        >
          <div
            v-if="parentProject?.attributes"
          >
            {{ $t('shared.partOf') }}:
            <I18nLink
              :to="{
                name: 'projects-slug',
                params: {
                  slug: parentProject?.attributes?.slug
                }
              }"
              :class="$style.link"
            >
              {{ parentProject?.attributes?.title }}
            </I18nLink>
          </div>

          <template
            #date
            v-if="page?.dateStart"
          >
            <SharedProjectsDatesComponent
              :dateStart="page?.dateStart"
              :dateEnd="page?.dateEnd"
              :ongoing="page?.ongoing"
              :hideMonths="page?.hideMonths"
              :hideDays="page?.hideDays"
            />
          </template>
        </LayoutHeadingComponent>

        <CoreBlocksImagesImageComponent
          v-if="page?.coverImage?.data?.attributes"
          :class="$style.coverImage"
          :image="page?.coverImage?.data"
        />

        <CoreBlocksComponent
          v-if="page?.blocks"
          :blocks="page?.blocks"
        />

        <SharedEmbeddedMapComponent
          v-if="page?.mapRepresentation?.mapLocation"
          :centerLatLong="page?.mapRepresentation?.mapLocation?.data?.attributes"
          :slug="page?.slug"
          :label="page?.mapRepresentation?.mapLocation?.data?.attributes?.title"
        />

        <SharedProjectsRelatedComponent
          v-if="page?.parentProjectEntry?.data"
          :items="[page?.parentProjectEntry?.data]"
        />

        <SharedProjectsRelatedComponent
          v-if="page?.childProjectEntries?.data?.length"
          :items="page?.childProjectEntries?.data"
        />

        <SharedCommunityRelatedComponent
          v-if="page?.communityEntries?.data?.length"
          :items="page?.communityEntries?.data"
        />

        <SharedCalendarRelatedComponent
          v-if="page?.calendarEntries?.data?.length"
          :items="page?.calendarEntries?.data"
        />

        <SharedBulletinBoardRelatedComponent
          v-if="page?.bulletinBoardEntries?.data?.length"
          :items="page?.bulletinBoardEntries?.data"
        />
      </template>
    </LayoutPageContentComponent>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  data: Object,
  parentTitle: {
    type: String,
    required: false
  },
})

const page = baseStrapiGetAttributes(props.data)

const parentProject = computed(() => {
  return page?.parentProjectEntry?.data
})

useHead({
  htmlAttrs: {
    style: '--color--background: var(--color--projects);'
  }
})

const projectAreas = props?.page?.projectAreas?.data || []
const projectCategories = props?.page?.projectCategories?.data || []
const categories = [...projectAreas?.sort(), ...projectCategories?.sort()]
</script>

<style module>
.root {
  padding: var(--padding--container);
  padding-top: 0;
}

.coverImage {
  --base--image--max-aspect-ratio: 6 / 9;
  margin-bottom: calc(var(--unit--vertical) * 2);
}

.link {
  composes: reset-link link from global;
}
</style>
